import * as React from 'react';
import { Modal } from '@doordash/component-modal';
import MembersStrings from './MembersStrings';
import { Text } from '@doordash/design-language';
import Button from '@doordash/component-button';
var ResendInvitesConfirmationModal = function (_a) {
    var totalPending = _a.totalPending, isSending = _a.isSending, shouldDisplayError = _a.shouldDisplayError, _b = _a.handleResendInvites, handleResendInvites = _b === void 0 ? null : _b, onClose = _a.onClose;
    var contentStrings = MembersStrings.resendInvitesConfirmationModal;
    var isPluralForm = totalPending > 1;
    var confirmationContent = isSending
        ? contentStrings.isSendingContent()
        : contentStrings.content(totalPending, isPluralForm);
    var title = !shouldDisplayError
        ? contentStrings.title(totalPending, isPluralForm)
        : contentStrings.errorTitle();
    return (React.createElement(Modal, { onClose: onClose, title: title, size: Modal.Sizes.Large, primaryAction: !shouldDisplayError
            ? {
                text: contentStrings.resendButton(),
                onClick: handleResendInvites,
                buttonProps: {
                    state: isSending
                        ? Button.States.Loading
                        : Button.States.Default,
                    size: Button.Sizes.Medium,
                },
            }
            : {
                text: contentStrings.errorCancelButon(),
                onClick: onClose,
            }, secondaryAction: !shouldDisplayError
            ? {
                text: contentStrings.cancelButton(),
                onClick: onClose,
                buttonProps: {
                    size: Button.Sizes.Medium,
                },
            }
            : null },
        React.createElement(Text, null, !shouldDisplayError
            ? confirmationContent
            : contentStrings.errorContent())));
};
export default ResendInvitesConfirmationModal;
